import { FC, SVGProps } from 'react';

export const AnnouncementHistoryIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M27.25 16C27.25 9.7868 22.2132 4.75 16 4.75C15.5858 4.75 15.25 4.41421 15.25 4C15.25 3.58579 15.5858 3.25 16 3.25C23.0416 3.25 28.75 8.95837 28.75 16C28.75 23.0416 23.0416 28.75 16 28.75C8.95837 28.75 3.25 23.0416 3.25 16C3.25 15.5858 3.58578 15.25 4 15.25C4.41421 15.25 4.75 15.5858 4.75 16C4.75 22.2132 9.7868 27.25 16 27.25C22.2132 27.25 27.25 22.2132 27.25 16Z"
			fill="currentColor"
		/>
		<path
			d="M13.2332 4.29628C13.3533 4.6927 13.1293 5.11142 12.7329 5.23153C12.5916 5.27432 12.4516 5.31981 12.3127 5.36795C11.9214 5.50365 11.4941 5.2964 11.3584 4.90505C11.2227 4.5137 11.43 4.08643 11.8213 3.95073C11.9788 3.89612 12.1377 3.84451 12.2979 3.79597C12.6943 3.67586 13.1131 3.89986 13.2332 4.29628Z"
			fill="currentColor"
		/>
		<path
			d="M9.75296 5.72487C9.9901 6.06449 9.90702 6.53204 9.56741 6.76917C9.44657 6.85355 9.32746 6.94024 9.21015 7.02918C8.88007 7.27942 8.40963 7.21471 8.15938 6.88463C7.90914 6.55455 7.97385 6.08411 8.30393 5.83387C8.43682 5.73311 8.57176 5.63491 8.70866 5.53931C9.04828 5.30218 9.51583 5.38525 9.75296 5.72487Z"
			fill="currentColor"
		/>
		<path
			d="M6.88463 8.15938C7.2147 8.40963 7.27942 8.88007 7.02918 9.21015C6.94024 9.32746 6.85355 9.44657 6.76917 9.56741C6.53204 9.90703 6.06449 9.9901 5.72487 9.75297C5.38525 9.51583 5.30218 9.04828 5.53931 8.70866C5.6349 8.57176 5.73311 8.43683 5.83386 8.30393C6.08411 7.97386 6.55455 7.90914 6.88463 8.15938Z"
			fill="currentColor"
		/>
		<path
			d="M4.90505 11.3584C5.2964 11.4941 5.50365 11.9214 5.36795 12.3128C5.31981 12.4516 5.27432 12.5916 5.23153 12.7329C5.11142 13.1293 4.6927 13.3533 4.29628 13.2332C3.89986 13.1131 3.67586 12.6943 3.79597 12.2979C3.84451 12.1377 3.89612 11.9788 3.95073 11.8213C4.08643 11.43 4.5137 11.2227 4.90505 11.3584Z"
			fill="currentColor"
		/>
		<path
			d="M15.6818 9.99999C16.0584 9.99999 16.3636 10.2878 16.3636 10.6428V15.0963L19.7643 17.871C20.0491 18.1033 20.0801 18.5093 19.8337 18.7778C19.5873 19.0463 19.1567 19.0756 18.872 18.8432L15.2356 15.8762C15.086 15.7541 15 15.5767 15 15.3901V10.6428C15 10.2878 15.3052 9.99999 15.6818 9.99999Z"
			fill="currentColor"
		/>
	</svg>
);
